<template>
  <div @keyup.enter="enterSearch">
    <el-row class="time-container" type="flex" justify="space-between" align="middle">
      <p>统计时间：{{nowTime}}</p>
      <el-radio-group v-model="timeType" @change="handleTimeTypeChange">
        <el-radio-button
          v-for="item in timeOptions"
          :key="item.value"
          :label="item.value">{{item.name}}</el-radio-button>
      </el-radio-group>
      <el-date-picker
        class="date-picker"
        v-if="timeType !== 1"
        v-model="time"
        @change="handleDateChange"
        :picker-options="pickerOptions"
        :type="timeOptions[timeType-(dataType === 1 ? 1 : 3)].type"
        :placeholder="`选择${timeOptions[timeType-(dataType === 1 ? 1 : 3)].name}`"
        :value-format="timeOptions[timeType-(dataType === 1 ? 1 : 3)].format">
      </el-date-picker>
    </el-row>
    <type-card-list :list="typeCardList" @item-click="handleCardClick"></type-card-list>
    <el-form :model="form" ref="form" label-width="80px" :inline="true">
      <el-form-item label="经营组织">
        <ajax-select
          v-model="form.org"
          type="org"
          valueField="obj"
          placeholder="请输入关键词"
          @change="handleOrgChange"></ajax-select>
      </el-form-item>
      <el-form-item label="商品名称">
        <search-select
          v-model="form.pro"
          placeholder="请输入关键词"
          type="product"
          clearable
          ref="proSelect"
          @change="handleProChange"
          :extra-params="{ deptID: form.org && form.org.id, itemType: 1}"></search-select>
      </el-form-item>
      <el-form-item label="数据维度" v-if="isSaleData">
        <el-select v-model="form.saleType" @change="handleSaleTypeChange">
          <el-option v-for="item in saleTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="币种" prop="currency">
        <el-select v-model="form.currency" placeholder="请选择" @change="currencyChange">
          <el-option :key="1" label="CNY" value="1"></el-option>
          <el-option :key="2" label="USD" value="2"></el-option>
          <el-option :key="3" label="EUR" value="3"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="echart-line-wrap" v-if="!(isSaleData && form.saleType === '')">
      <echarts-line :series-data="dataList" :extra-option="extraOption"/>
    </div>
    <export-table :columnList="columnList" :list="tableList" @export="batchExport"/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import AjaxSelect from '@/components/ajaxSelect'
import SearchSelect from '@/components/searchSelect'
import ExportTable from '../components/exportTable.vue'
import TypeCardList from '../components/typeCardList'
import EchartsLine from '@/components/echarts'
import { columnMap, cardDataList } from './dataMap'

export default {
  name: 'DataBoardSaleData',
  components: { AjaxSelect, SearchSelect, TypeCardList, ExportTable, EchartsLine },
  data () {
    return {
      nowTime: new Date().toLocaleString(),
      timeType: 1,
      time: '',
      dataType: 1,
      form: {
        org: { id: '', name: '全部' },
        pro: '',
        saleType: '',
        currency: '1' // 币种
      },
      tableList: [],
      xAxisNames: [],
      dataList: [],
      typeCardList: cardDataList,
      proUnit: '',
      pickerOptions: { // 禁用当日，不影响月、年选择
        disabledDate (time) {
          return time.getTime() < Date.now() && time.getTime() > Date.now() - 8.64e7
        }
      }
    }
  },
  computed: {
    timeOptions () {
      let arr = [
        {
          name: '月',
          value: 3,
          type: 'month',
          format: 'yyyy-MM'
        },
        {
          name: '年',
          value: 4,
          type: 'year',
          format: 'yyyy'
        }
      ]
      if (this.isSaleData) {
        arr = [
          {
            name: '实时',
            value: 1,
            type: '',
            format: ''
          },
          {
            name: '日',
            value: 2,
            type: 'date',
            format: 'yyyy-MM-dd'
          },
          ...arr
        ]
      }
      return arr
    },
    saleTypeOptions () {
      const list = columnMap[0].slice(1).map(item => ({
        label: item.label,
        value: item.prop
      }))
      const proSearchList = list.filter((item, index) => index !== 2)
      return this.isAllPro ? proSearchList : list
    },
    isAllPro () { // 搜索条件是否所有商品
      return this.form.pro === ''
    },
    isSaleData () {
      return this.dataType === 1
    },
    visualType () {
      return this.isSaleData ? 'bar' : 'line'
    },
    columnList () {
      let list = columnMap[this.dataType - 1]
      const orgAndPro = [
        {
          label: '经营组织',
          prop: 'org'
        },
        {
          label: '商品名称',
          prop: 'pro'
        }
      ]
      list = [
        list[0],
        ...orgAndPro,
        ...list.slice(1)
      ]
      return list
    },
    yAxisUnit () {
      if (this.isSaleData) {
        const map = {
          orderQuantity: '张',
          orderAmount: this.form.currency === '1' ? '万元' : '',
          orderSendQuantity: this.proUnit,
          orderSendAmount: this.form.currency === '1' ? '万元' : ''
        }
        return map[this.form.saleType]
      } else {
        return '%'
      }
    },
    extraOption () {
      let yAxis = {
        axisLabel: {
          formatter: `{value}${this.yAxisUnit}`
        },
        minInterval: 1 // 只显示整数
      }
      if (this.form.currency === '2') {
        yAxis.name = 'USD'
        yAxis.nameLocation = 'center'
        yAxis.nameGap = 80
      } else if (this.form.currency === '3') {
        yAxis.name = 'EUR'
        yAxis.nameLocation = 'center'
        yAxis.nameGap = 80
      }
      const obj = {
        title: { text: this.typeCardList[this.dataType - 1].title },
        xAxis: { data: this.xAxisNames, boundaryGap: this.isSaleData },
        yAxis: yAxis
      }
      return obj
    },
    // 实时
    isNow () {
      return this.timeType === 1
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['getDataBoardSaleDataList', 'exportDataBoardSaleData']),
    todayStr (type) {
      const dateStr = this.nowTime.match(/^[\d/]+/g)
      const dateArr = dateStr[0].split('/')
      const year = dateArr[0]
      const month = dateArr[1] < 10 ? '0' + dateArr[1] : dateArr[1]
      const day = dateArr[2] < 10 ? '0' + dateArr[2] : dateArr[2]
      switch (type) {
        case 'month':
          return year + '-' + month
        case 'year':
          return year
        default:
          return year + '-' + month + '-' + day
      }
    },
    handleOrgChange (v) {
      // 有商品筛选条件时清空商品
      this.form.pro = ''
      this.proUnit = ''
      this.form.saleType = ''
      this.$nextTick(() => {
        this.$refs['proSelect'].initOption()
      })
      this.getData()
    },
    handleProChange (val) {
      if (val) {
        this.proUnit = val.unit
      } else {
        this.proUnit = ''
      }
      this.form.saleType = ''
      this.getData()
    },
    handleTimeTypeChange (v) {
      this.time = ''
      if (v === 1) {
        this.getData()
      }
    },
    handleDateChange (v) {
      if (v) {
        this.getData()
      }
    },
    handleSaleTypeChange (v) {
      this.getData()
    },
    // 币种改变
    currencyChange () {
      this.getData()
    },
    handleCardClick (info, index) {
      const oldIndex = this.dataType
      this.dataType = index + 1
      if (oldIndex === 1 && index + 1 !== 1) { // 从销售数据到其他类型时重置为月份
        this.timeType = 3
      }
      this.$nextTick(() => {
        if (this.timeType !== 1) { // 未选择日期时默认查当日/月/年
          const map = {
            2: 'day',
            3: 'month',
            4: 'year'
          }
          this.time = this.todayStr(map[this.timeType])
        }
        this.$nextTick(() => {
          this.getData()
        })
      })
    },
    validDate () {
      // 日月年要选择特定日期
      if (!this.isNow && !this.time) {
        this.$message.warning('请选择一个日期来搜索数据')
        return false
      }
      return true
    },
    formatTableList (list) {
      return list.map(item => ({
        ...item,
        org: this.form.org.name,
        pro: this.form.pro ? this.form.pro.name : '全部',
        orderQuantityRatio: item.orderQuantityRatio + '%',
        orderAmountRatio: item.orderAmountRatio + '%',
        orderSendQuantityRatio: item.orderSendQuantityRatio + '%',
        orderSendAmountRatio: item.orderSendAmountRatio + '%'
      }))
    },
    getData () {
      if (!this.validDate()) {
        return
      }
      const params = this.formatParams()
      this.getDataBoardSaleDataList(params).then(res => {
        this.tableList = this.formatTableList(res)
        console.log('获取数据res=', res)
        this.getVisualLists(res)
      }).catch(() => {
        this.tableList = []
        this.dataList = []
      })
    },
    formatParams () {
      const { org, pro } = this.form
      let params = {
        time: this.isNow ? this.todayStr() : this.time,
        timeType: this.timeType,
        tabType: this.dataType,
        deptId: org.id,
        currencyType: Number(this.form.currency),
        itemName: pro.name
      }
      return params
    },
    getVisualLists (list) {
      const data = []
      const x = []
      let map = {
        1: [
          'orderQuantity',
          'orderAmount',
          'orderSendQuantity',
          'orderSendAmount'
        ],
        2: [
          'orderQuantityRatio',
          'orderAmountRatio',
          'orderSendQuantityRatio',
          'orderSendAmountRatio'
        ],
        3: [
          'orderQuantityRatio',
          'orderAmountRatio',
          'orderSendQuantityRatio',
          'orderSendAmountRatio'
        ]
      }
      // 组装各条数据值
      list.forEach(item => {
        map[this.dataType].forEach((v, i) => {
          if (data[i] && Array.isArray(data[i])) {
            data[i].push(item[v])
          } else {
            data[i] = [item[v]]
          }
        })
        x.push(item.time)
      })
      this.xAxisNames = x
      this.dataList = this.formatSeries(map, data)
      console.log('this.dataList=', this.dataList)
    },
    formatSeries (map, data) {
      if (!this.isSaleData) {
        return map[this.dataType].map((item, index) => {
          return {
            name: this.getListName(item),
            type: this.visualType,
            data: data[index],
            smooth: true,
            symbol: 'none'
          }
        })
      }
      const i = map[1].findIndex(item => item === this.form.saleType)
      return [{
        name: this.getListName(this.form.saleType),
        type: this.visualType,
        data: data[i]
      }]
    },
    getListName (prop) {
      if (prop) {
        return columnMap[this.dataType - 1].find(item => item.prop === prop).label
      }
    },
    batchExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = this.formatParams()
        this.exportDataBoardSaleData(params).then(res => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '统计数据.xls'
            // 兼容 IE系列 浏览器
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.time-container{
  padding-bottom: 50px;
}
.select{
  position: absolute;
  left: 0;
  top: 40px;
}
.date-picker{
  position: absolute;
  right: 0;
  top: 40px;
}
.echart-line-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80vh;
  margin: 20px auto;
}
</style>
